import { render } from "./editSignerComponent.vue?vue&type=template&id=17f74d7c&scoped=true"
import script from "./editSignerComponent.vue?vue&type=script&lang=js"
export * from "./editSignerComponent.vue?vue&type=script&lang=js"

import "./editSignerComponent.vue?vue&type=style&index=0&id=17f74d7c&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17f74d7c"]])

export default __exports__